module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_reason03-a7f3f168a985feadb1bee8094de8ad7b.png";